/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ClaimFeedbackCreate = {
    resolutionReason: string;
    resolutionStatus: ClaimFeedbackCreate.resolutionStatus;
    englishHeader: string;
    frenchHeader: string;
    englishMessage: string;
    frenchMessage: string;
};

export namespace ClaimFeedbackCreate {

    export enum resolutionStatus {
        CONFIRMED = 'CONFIRMED',
        PARTIALLY_CONFIRMED = 'PARTIALLY_CONFIRMED',
        DECLINED = 'DECLINED',
    }


}

